// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { styles } from "@bg/App/Components/RecentWishListCard/RecentWishListCard";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.addToCart = {
    variant: "tertiary",
    sizeVariant: "medium",
    css: css`
        svg {
            color: ${getColor("tertiary")};
            circle {
                stroke: ${getColor("tertiary")};
            }
        }
        && :hover {
            svg {
                color: ${getColor("common.white")} !important;
            }
        }
    `,
};

styles.actionsWrapper = {
    css: css`
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .loading-bgs {
            &:disabled {
                border: 0 !important;
                opacity: 1 !important;
            }
        }
    `,
};
